export default theme => ({
  wrapper: {
    color: '#8b8c8d',
    fontSize: 11,
    // paddingBottom: 8,
    // paddingTop: 0
  },
  container: {
    padding: '3px 15px'
  }
});